import BestWorstPerformer from "../../Reusable/BestWorstPerformer";
import BarChart from "../../BarChart/BarChart";
import AssetAllocation from "./AssetAllocation/AssetAllocation";
import PortfolioAgeing from "./PortfolioAgeing/PortfolioAgeing";
import InvestmentValue from "./InvestmentValue/InvestmentValue";
import PortfolioAllocation from "./PortfolioAllocation/PortfolioAllocation";
import CategoryExposure from "./CategoryExposure/CategoryExposure";
import { useEffect, useState } from "react";
import { observer } from "mobx-react";
import EmptyScreen from "../Equity/EmptyScreen/EmptyScreen";
import apiClient from "../../../api";
import {
  getAmcExposure,
  getFamilyAssetAllocationOverTime,
  getInvestmentValue,
  getMfExposure,
  getPortfolioAgeing,
  getPortfolioAgeingOptions,
  getPortfolioAllocation,
  getPortfolioAssetClasses,
} from "../../../api/hooks/overall";
import UserStore from "../../../store/UserStore";
import AnalyticsStore from "../../../store/AnalyticsStore";
import InternalTabsAnalytics from "../Equity/InternalTabsAnalytics/InternalTabsAnalytics";
import { setCookie, getCookie } from "../../../utils/cookie";
import Log from "../Equity/Log";
import loaderGIF from "../../../assets/images/gifs/loaderGIF.gif";
import { tabData } from "../../../utils/constants";
import {
  commaSeperated2,
  displayUnit,
  getGraphDataInSortedOrder,
} from "../../../utils/functions";
import { useRef } from "react";
import moment from "moment";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";

const Overall = observer(
  forwardRef(({ snippetDuration }, ref) => {
    //const [isPerformLoading, setIsPerformLoading] = useState(true);

    const assetRef = useRef(null);
    const amcExRef = useRef(null);
    const overallDurationRef = useRef(null);

    // Exposing multiple refs via useImperativeHandle
    useImperativeHandle(ref, () => ({
      assetRef: assetRef.current,
      amcExRef: amcExRef.current,
      overallDurationRef: overallDurationRef.current,
    }));

    const [chartData, setCharData] = useState();
    const usersId = AnalyticsStore.overall?.userId;
    const isFam = UserStore.getData;

    const refFun = useRef();
    const [allAssetClassMenuOpen, setAllAssetClassMenuOpen] = useState(false);
    const [isDropDownClosed, setIsDropDownClosed] = useState(false);
    const [portfolioAgeingDataCount, setPortfolioAgeingDataCount] = useState(6);
    const [selectedAssetClass, setSelectedAssetClass] = useState("All");
    const [portfolioAgeingData, setPortfolioAgeingData] = useState([]);
    const [instrumentData, setInstrumentData] = useState([]);
    const [familyOptions, setFamilyOptions] = useState([]);
    const [portfolioDataStatus, setPortfolioDataStatus] = useState();
    const [tableData, setTableData] = useState([]);
    const [order, setOrder] = useState(null);
    const [sortField, setSortField] = useState("");
    const [currentSortKey, setCurrentSortKey] = useState("");

    let categoriesData = [];
    const [investmentData, setInvestmentData] = useState([]);
    const [investmentValue, setInvestmentValue] = useState("");
    const [investmentType, setInvestmentType] = useState("");
    const [currentValue, setCurrentValue] = useState("");
    const [currentType, setCurrentType] = useState("");
    const [graphData, setGraphData] = useState([]);

    const [amcData, setAmcData] = useState([]);
    const marketCapDropdownItems = [
      { id: 0, value: "Across Categories" },
      { id: 2, value: "Equity" },
      { id: 4, value: "Fixed Income" },
    ];

    const marketCapDropdownItems1 = [
      { id: 0, value: "Across Categories" },
      { id: 2, value: "Equity" },
      { id: 4, value: "Fixed Income" },
    ];
    const [selectedAccount1, setSelectedAccount1] = useState(
      marketCapDropdownItems[0]
    );

    const [selectedAccount2, setSelectedAccount2] = useState(
      marketCapDropdownItems1[0]
    );
    const [categoryData, setCategoryData] = useState([]);

    const storeUserId = UserStore.userId;
    const [portfolioAllocationData, setPortfolioAllocationData] = useState([]);

    const [isBestLoading, setIsBestLoading] = useState(true);
    const [isWorstLoading, setIsWorstLoading] = useState(true);
    const [bestLength, setBestLength] = useState(0);
    const [worstLength, setWorstLength] = useState(0);

    const [activeTab, setActiveTab] = useState(
      snippetDuration || tabData[3].name
    );
    const [selectedRadioBtn, setSelectedRadioBtn] = useState("irr");
    const [bestAndWorstDropdownItems, setBestAndWorstDropdownItems] = useState(
      []
    );

    const [renderCondition, seTrenderCondition] = useState(false);
    const selectedItemBestAndWorst =
      AnalyticsStore.overall.selectedItemBestAndWorst;
    const familyId = UserStore?.userData?.family_id || getCookie("famid");
    const isPrimary =
      (AnalyticsStore?.overall?.isPrimary ||
        JSON.parse(getCookie("isPrimary"))) &&
      UserStore.getData === "fam"
        ? true
        : false;
    const userId =
      !isPrimary && (AnalyticsStore?.overall?.userId || getCookie("userid"));

    // const isPrimary =
    //   (AnalyticsStore?.overall?.isPrimary ||
    //     JSON.parse(getCookie("isPrimary"))) &&
    //   UserStore.getData === "fam"
    //     ? true
    //     : false;
    // const userId =
    //   !isPrimary && (AnalyticsStore?.overall?.userId || getCookie("userid"));

    // const checkPerformLoadingStatus = () => {
    //   if (
    //     !AnalyticsStore.overall.bestPerformerLoading &&
    //     !AnalyticsStore.overall.worstPerformerLoading
    //   ) {
    //     setIsPerformLoading(false);
    //   }
    // };

    useEffect(() => {
      let familyId = UserStore?.userData?.family_id;
      let userId = UserStore?.userData?.user_id;
      if (familyId) {
        setCookie("familyId", familyId);
      } else {
        familyId = getCookie("familyId");
      }
      if (!userId) {
        userId = getCookie("userid");
      }

      getPortfolioAssetClasses(familyId).then((response) => {
        setBestAndWorstDropdownItems([
          {
            id: "0",
            name: "Across categories",
          },
          ...response.data,
        ]);
        AnalyticsStore.setOverall({
          ...AnalyticsStore.overall,
          portfolioAssetClass: response.data,
        });
      });
      setSelectedRadioBtn("irr");
    }, [userId]);

    useEffect(() => {
      const getPerformers = (bestPerformer = true) => {
        //setIsPerformLoading(true);
        if (bestPerformer) {
          AnalyticsStore.setOverall({
            ...AnalyticsStore.overall,
            bestPerformer: [],
            performerLoading: true,
            bestPerformerLoading: true,
          });
          setIsBestLoading(true);
          setBestLength(0);
        } else {
          AnalyticsStore.setOverall({
            ...AnalyticsStore.overall,
            worstPerformer: [],
            performerLoading: true,
            worstPerformerLoading: true,
          });
          setIsWorstLoading(true);
          setWorstLength(0);
        }
        const uri = !userId
          ? `families/${familyId}/analytics/performers`
          : `clients/${userId}/analytics/performers`;
        apiClient
          .get(uri, {
            params: {
              type: bestPerformer ? "best" : "worst",
              duration: activeTab,
              asset_class_id:
                AnalyticsStore.overall?.selectedItemBestAndWorst?.id,
              instrumentvehicleid: "",
              return_type: "",
              is_xirr: selectedRadioBtn,
            },
          })
          .then((res) => {
            if (bestPerformer) {
              AnalyticsStore.setOverall({
                ...AnalyticsStore.overall,
                bestPerformer: res.data,
                performerLoading: false,
                bestPerformerLoading: false,
              });
              setIsBestLoading(false);
              setBestLength(res.data.length);
              //checkPerformLoadingStatus();
            } else {
              AnalyticsStore.setOverall({
                ...AnalyticsStore.overall,
                worstPerformer: res.data,
                performerLoading: false,
                worstPerformerLoading: false,
              });
              setIsWorstLoading(false);
              //checkPerformLoadingStatus();
              setWorstLength(res.data.length);
            }
          })
          .catch((err) => {
            Log("Error : ", err);
            AnalyticsStore.setOverall({
              ...AnalyticsStore.overall,
              performerLoading: false,
              bestPerformerLoading: false,
              worstPerformerLoading: false,
            });
            setIsBestLoading(false);
            setIsWorstLoading(false);
            //checkPerformLoadingStatus();
            setWorstLength(0);
            setBestLength(0);
          });
      };

      getPerformers(true);
      getPerformers(false);
    }, [
      selectedItemBestAndWorst,
      selectedRadioBtn,
      activeTab,
      userId,
      familyId,
    ]);

    function showDropdownOfBestAndWorst() {
      const ret =
        AnalyticsStore?.overall?.selectedItemBestAndWorst?.name ===
        "Across Categories"
          ? AnalyticsStore.overall.bestPerformer?.length > 0 ||
            AnalyticsStore.overall.worstPerformer.length > 0 ||
            activeTab !== "ITD" ||
            isBestLoading ||
            isWorstLoading
          : true;
      return ret;
    }

    // const showDropdownOfBestAndWorst = useCallback(() => {
    //   const ret =
    //     AnalyticsStore?.overall?.selectedItemBestAndWorst?.name ===
    //     "Across Categories"
    //       ? AnalyticsStore.overall.bestPerformer?.length > 0 ||
    //         AnalyticsStore.overall.worstPerformer.length > 0 ||
    //         activeTab !== "ITD"
    //       : // ||
    //         // isBestLoading ||
    //         // isWorstLoading
    //         true;
    //   return ret;
    // }, [
    //   AnalyticsStore.overall.bestPerformer?.length,
    //   activeTab,
    //   AnalyticsStore?.overall?.selectedItemBestAndWorst?.name,
    //   AnalyticsStore.overall.worstPerformer.length,
    // ]);

    const allObjectsHaveEmptyArray =
      AnalyticsStore.overall.portfolioAllocation?.every((obj) => {
        return (
          Array.isArray(obj.assetClassAllocations) &&
          obj.assetClassAllocations.length === 0
        );
      });

    const handleSorting = (sortField, sortOrder) => {
      if (tableData && sortField !== "value") {
        const sorted = tableData.sort((a, b) => {
          return (
            a[sortField]
              .toString()
              .localeCompare(b[sortField].toString(), "en", {
                numeric: true,
              }) * (sortOrder === "asc" ? 1 : -1)
          );
        });
        setTableData(sorted);
      } else {
        let sorted = tableData.sort((a, b) =>
          Math.abs(a.actualValue) > Math.abs(b.actualValue)
            ? 1
            : Math.abs(b.actualValue) > Math.abs(a.actualValue)
            ? -1
            : 0
        );
        if (sortOrder === "desc") {
          sorted.reverse();
        }
        setTableData(sorted);
      }
    };

    const handleSortingChange = (accessor) => {
      setCurrentSortKey(accessor);
      const sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      setSortField(accessor);
      setOrder(sortOrder);
      handleSorting(accessor, sortOrder);
    };

    useEffect(() => {
      const familyId = UserStore.userData.family_id;
      const userId = UserStore.userData.user_id;

      getFamilyAssetAllocationOverTime(familyId, userId).then((response) => {
        AnalyticsStore.setOverall({
          ...AnalyticsStore.overall,
          familyAssetAllocationOverTime: [],
          assetAllocationLoading: false,
        });
        if (response.data.length > 0) {
          for (let i = 0; i < response?.data?.length; i++) {
            for (let j = 0; j < response.data[i].assetAllocations.length; j++) {
              const val_type =
                response.data[i].assetAllocations[j].assetAllocation
                  .currentValue.value_type;
              const val =
                response.data[i].assetAllocations[j].assetAllocation
                  .currentValue.value;
              const allocation_percentage =
                response.data[i].assetAllocations[j].assetAllocation
                  .allocation_percentage;
              response.data[i].assetAllocations[
                j
              ].assetAllocation.currentValue.value_type =
                val_type === "lacs" ? "L" : val_type === "k" ? "K" : val_type;
              response.data[i].assetAllocations[
                j
              ].assetAllocation.currentValue.value = commaSeperated2(val);
              response.data[i].assetAllocations[
                j
              ].assetAllocation.allocation_percentage = commaSeperated2(
                allocation_percentage
              );
            }
          }
          const sortedDatas = [...response?.data].sort(
            (a, b) => new Date(a.date) - new Date(b.date)
          );
          AnalyticsStore.setOverall({
            ...AnalyticsStore.overall,
            familyAssetAllocationOverTime: sortedDatas,
            assetAllocationLoading: false,
          });
          setCharData(response.data);
        } else {
          setCharData(null);
        }
      });
      // eslint-disable-next-line
    }, [usersId, isFam]);

    useEffect(() => {
      let familyId = UserStore?.userData?.family_id;
      if (familyId) {
        setCookie("familyId", familyId);
      } else {
        familyId = getCookie("familyId");
      }
      setPortfolioAgeingDataCount(6);
      getPortfolioAgeingOptions(familyId).then((response) => {
        let familyOptionsObj = [];
        let familyOptionsId = [];

        response.data.map((data) => {
          let obj = {
            id: data.id,
            clientcode: data.clientcode,
            name: data.name,
            checked: false,
          };
          familyOptionsObj.push(obj);
          familyOptionsId.push(obj.id);
          return false;
        });
        setSelectedAssetClass([...familyOptionsId]);
        setFamilyOptions(familyOptionsObj);
        setAllAssetClassMenuOpen(true);
        setTimeout(() => {
          setAllAssetClassMenuOpen(false);
          setIsDropDownClosed(true);
        }, 10);
      });
    }, [userId]);

    const assetClassFun = () => {
      if (!allAssetClassMenuOpen) {
        let familyId = UserStore?.userData?.family_id;
        let userId = UserStore?.userData?.user_id;
        if (familyId) {
          setCookie("familyId", familyId);
        } else {
          familyId = getCookie("familyId");
        }
        if (selectedAssetClass?.length > 0 && selectedAssetClass !== "All") {
          getPortfolioAgeing(familyId, userId, selectedAssetClass).then(
            (response) => {
              AnalyticsStore.setOverall({
                ...AnalyticsStore.overall,
                portfolioAgeing: response.data,
                portfolioAgeingLoading: false,
              });
              setPortfolioAgeingData(response.data);
              setInstrumentData(response);
              selectedAssetClass.length === familyOptions.length &&
                setPortfolioDataStatus(
                  response.data?.length > 0 ? true : false
                );
              if (!isDropDownClosed) handleSorting("days_held", "desc");
            }
          );
        } else if (
          selectedAssetClass.length === 0 &&
          selectedAssetClass !== "All"
        ) {
          AnalyticsStore.setOverall({
            ...AnalyticsStore.overall,
            portfolioAgeing: [],
          });
          setPortfolioAgeingData([]);
        }
      }
    };

    refFun.current = assetClassFun;

    useEffect(() => {
      refFun.current();
    }, [allAssetClassMenuOpen]);

    useEffect(() => {
      let graphValue = [];
      let familyId = UserStore?.userData?.family_id;
      if (familyId) {
        setCookie("familyId", familyId);
      } else {
        familyId = getCookie("familyId");
      }
      AnalyticsStore.setOverall({
        ...AnalyticsStore.overall,
        investmentValue: [],
        investmentLoading: true,
      });
      getInvestmentValue(familyId, userId)
        .then((response) => {
          setInvestmentValue(
            `${commaSeperated2(
              response.data[0]?.investmentReturn?.invested_value.value
            )}`
          );
          setInvestmentType(
            displayUnit(
              response.data[0]?.investmentReturn.invested_value.value_type
            )
          );
          setCurrentValue(
            `${commaSeperated2(
              response.data[0]?.investmentReturn.current_value.value
            )} `
          );
          setCurrentType(
            displayUnit(
              response.data[0]?.investmentReturn.current_value.value_type
            )
          );

          let investmentObj = {
            name: "Investment Value",
          };

          let currentObj = {
            name: "Current Value",
          };

          let investmentData = [];
          let currentData = [];

          response.data[0]?.investmentReturnTimelines.map((item) => {
            investmentData.push(item.modelCategory?.invested_value?.value);
            currentData.push(item.modelCategory?.current_value?.value);
            categoriesData.push(
              moment(item.date, "YYYY-MM-DD").format("DD MMM YYYY")
            );
            return false;
          });

          setGraphData(
            getGraphDataInSortedOrder({
              data: response.data[0]?.investmentReturnTimelines,
            })
          );

          investmentObj["data"] = investmentData;
          currentObj["data"] = currentData;

          graphValue.push(investmentObj);
          graphValue.push(currentObj);

          graphValue.push();
          AnalyticsStore.setOverall({
            ...AnalyticsStore.overall,
            investmentCategories: categoriesData,
          });
          AnalyticsStore.setOverall({
            ...AnalyticsStore.overall,
            investmentValue: response.data,
            investmentLoading: false,
          });
          setInvestmentData(response?.data?.length ? graphValue : []);
        })
        .catch((err) => {
          AnalyticsStore.setOverall({
            ...AnalyticsStore.overall,
            investmentLoading: false,
          });
        });
      return () => {
        setInvestmentData([]);
        setGraphData([]);
      };
      // eslint-disable-next-line
    }, [userId]);

    useEffect(() => {
      let familyId = UserStore?.userData?.family_id;
      let userId = UserStore?.userData?.user_id;
      if (familyId) {
        setCookie("familyId", familyId);
      } else {
        familyId = getCookie("familyId");
      }
      if (!userId) {
        userId = getCookie("userid");
      }
      setAmcData([]);
      AnalyticsStore.setOverall({
        ...AnalyticsStore.overall,
        amcExposureLoading: true,
      });
      getAmcExposure(familyId, userId, selectedAccount1.id).then((response) => {
        setAmcData(response.data);
        AnalyticsStore.setOverall({
          ...AnalyticsStore.overall,
          amcExposure: response.data,
          amcExposureLoading: false,
        });
      });
    }, [selectedAccount1]);

    useEffect(() => {
      let familyId = UserStore?.userData?.family_id;
      let userId = UserStore?.userData?.user_id;
      if (familyId) {
        setCookie("familyId", familyId);
      } else {
        familyId = getCookie("familyId");
      }
      if (!userId) {
        userId = getCookie("userid");
      }
      setCategoryData([]);
      AnalyticsStore.setOverall({
        ...AnalyticsStore.overall,
        mfExposureLoading: true,
      });

      getMfExposure(familyId, userId, selectedAccount2.id).then((response) => {
        setCategoryData(response.data);
        AnalyticsStore.setOverall({
          ...AnalyticsStore.overall,
          categoryExposure: response.data,
          mfExposureLoading: false,
        });
      });
    }, [selectedAccount2]);

    useEffect(() => {
      let familyId = UserStore?.userData?.family_id;
      let userId = UserStore?.userData?.user_id;
      if (familyId) {
        setCookie("familyId", familyId);
      } else {
        familyId = getCookie("familyId");
      }
      if (!userId) {
        userId = getCookie("userid");
      }
      AnalyticsStore.setOverall({
        ...AnalyticsStore.overall,
        portfolioAllocation: [],
        portfolioAllocationLoading: false,
      });
      getPortfolioAllocation(familyId, userId).then((response) => {
        AnalyticsStore.setOverall({
          ...AnalyticsStore.overall,
          portfolioAllocation: response.data,
          portfolioAllocationLoading: false,
        });
        setPortfolioAllocationData(response.data);
      });
    }, [storeUserId]);

    useEffect(() => {
      if (
        AnalyticsStore.overall.bestPerformer?.length > 0 ||
        AnalyticsStore.overall.worstPerformer?.length > 0 ||
        AnalyticsStore.overall.familyAssetAllocationOverTime?.length > 0 ||
        AnalyticsStore.overall.portfolioAgeing?.length > 0 ||
        AnalyticsStore.overall.investmentValue?.length > 0 ||
        AnalyticsStore.overall.amcExposure?.length > 0 ||
        AnalyticsStore.overall.performerLoading ||
        AnalyticsStore.overall.categoryExposure?.length > 0
      )
        seTrenderCondition(true);
      else seTrenderCondition(false);
    }, [AnalyticsStore.overall]);

    return (
      <div>
        {renderCondition ||
        // AnalyticsStore.overall.bestPerformer?.length > 0 ||
        // AnalyticsStore.overall.worstPerformer?.length > 0 ||
        // AnalyticsStore.overall.familyAssetAllocationOverTime?.length > 0 ||
        // AnalyticsStore.overall.portfolioAgeing?.length > 0 ||
        // AnalyticsStore.overall.investmentValue?.length > 0 ||
        // AnalyticsStore.overall.amcExposure?.length > 0 ||
        // AnalyticsStore.overall.performerLoading ||
        // AnalyticsStore.overall.categoryExposure?.length > 0 ||
        !allObjectsHaveEmptyArray ||
        showDropdownOfBestAndWorst() ? (
          <>
            <div className="analytics__internal__tab analytics-card">
              {/* best and worst performer filter */}
              <BestWorstPerformer
                dropdownItems={bestAndWorstDropdownItems}
                selectedItem={
                  AnalyticsStore.overall.selectedItemBestAndWorst === undefined
                    ? {
                        id: "0",
                        name: "Across Categories",
                      }
                    : AnalyticsStore.overall.selectedItemBestAndWorst
                }
                onChangeSelectedItem={(i) =>
                  AnalyticsStore.setOverall({
                    ...AnalyticsStore.overall,
                    selectedItemBestAndWorst: i,
                  })
                }
                selectedRadioBtn={selectedRadioBtn}
                onChangeRadioBtn={(val) => {
                  setIsBestLoading(true);
                  setIsWorstLoading(true);
                  setSelectedRadioBtn(val);
                }}
                isData={showDropdownOfBestAndWorst()}
                loading={
                  AnalyticsStore.overall.bestPerformerLoading ||
                  AnalyticsStore.overall.worstPerformerLoading
                }
              />
              {/* duration filter */}
              {(AnalyticsStore.overall.bestPerformer?.length > 0 ||
                AnalyticsStore.overall.worstPerformer?.length > 0 ||
                activeTab !== "ITD" ||
                isBestLoading ||
                isWorstLoading) && (
                <InternalTabsAnalytics
                  tabsDataProp={tabData}
                  setSelectedTab={(data, index) => {
                    setIsBestLoading(true);
                    setIsWorstLoading(true);
                    // setIsPerformLoading(true);
                    setActiveTab(data);
                  }}
                  selectedTab={activeTab}
                  ref={overallDurationRef}
                />
              )}
              {/* best and worst performer  */}
              {
                // (AnalyticsStore.overall.bestPerformer?.length > 0 ||
                //   AnalyticsStore.overall.worstPerformer?.length > 0) &&
                isBestLoading || isWorstLoading ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      margin: "170px 0px",
                    }}
                  >
                    <img style={{ height: "40px" }} src={loaderGIF} alt="" />
                  </div>
                ) : bestLength > 0 || worstLength > 0 ? (
                  // (!AnalyticsStore.overall.bestPerformerLoading ||
                  //   !AnalyticsStore.overall.worstPerformerLoading)
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    <span style={{ width: "50%" }}>
                      <span className="sub-title">Best Performers</span>
                      {AnalyticsStore.overall.bestPerformer.length > 0 ? (
                        <BarChart
                          containerStyles={{ marginRight: 60 }}
                          data={AnalyticsStore.overall.bestPerformer}
                          is_xirr={selectedRadioBtn}
                        />
                      ) : (
                        AnalyticsStore.overall.bestPerformer.length === 0 && (
                          <EmptyScreen
                            height={350}
                            loading={
                              AnalyticsStore.overall.bestPerformerLoading
                            }
                          />
                        )
                      )}
                    </span>
                    <span style={{ width: "50%" }}>
                      <span className="sub-title">Worst Performers</span>
                      {AnalyticsStore.overall.worstPerformer.length > 0 ? (
                        <BarChart
                          data={AnalyticsStore.overall.worstPerformer}
                          is_xirr={selectedRadioBtn}
                        />
                      ) : (
                        AnalyticsStore.overall.worstPerformer?.length === 0 && (
                          <EmptyScreen
                            height={350}
                            loading={
                              AnalyticsStore.overall.worstPerformerLoading
                            }
                          />
                        )
                      )}
                    </span>
                  </div>
                ) : (
                  <EmptyScreen
                    loading={
                      false
                      // isPerformLoading ||
                      // AnalyticsStore.overall.bestPerformerLoading ||
                      // AnalyticsStore.overall.worstPerformerLoading
                    }
                    height={350}
                  />
                )
              }
            </div>
            <div className="analytics-card" ref={assetRef} id="AssetAllocation">
              <AssetAllocation chartData={chartData} />
            </div>
            <div className="analytics-card overall_analytics_card">
              <PortfolioAgeing
                portfolioAgeingDataCount={portfolioAgeingDataCount}
                portfolioAgeingData={portfolioAgeingData}
                instrumentData={instrumentData}
                portfolioDataStatus={portfolioDataStatus}
                familyOptions={familyOptions}
                tableData={tableData}
                order={order}
                allAssetClassMenuOpen={allAssetClassMenuOpen}
                selectedAssetClass={selectedAssetClass}
                currentSortKey={currentSortKey}
                setPortfolioAgeingDataCount={setPortfolioAgeingDataCount}
                setAllAssetClassMenuOpen={setAllAssetClassMenuOpen}
                setSelectedAssetClass={setSelectedAssetClass}
                setTableData={setTableData}
                handleSortingChange={(accessor) =>
                  handleSortingChange(accessor)
                }
                setIsDropDownClosed={setIsDropDownClosed}
                setCurrentSortKey={setCurrentSortKey}
                setSortField={setSortField}
                setOrder={setOrder}
              />
            </div>
            <div className="analytics-card">
              <InvestmentValue
                investmentData={investmentData}
                investmentValue={investmentValue}
                investmentType={investmentType}
                currentValue={currentValue}
                currentType={currentType}
                graphData={graphData}
              />
            </div>
            <div className="" id="AMC_Exposure" ref={amcExRef}>
              <CategoryExposure
                amcData={amcData}
                marketCapDropdownItems={marketCapDropdownItems}
                marketCapDropdownItems1={marketCapDropdownItems1}
                selectedAccount1={selectedAccount1}
                selectedAccount2={selectedAccount2}
                userId={userId}
                categoryData={categoryData}
                setSelectedAccount2={setSelectedAccount2}
                setSelectedAccount1={setSelectedAccount1}
              />
            </div>
            <div className="analytics-card" style={{ marginBottom: "6%" }}>
              <PortfolioAllocation
                portfolioAllocationData={portfolioAllocationData}
              />
            </div>
          </>
        ) : (
          <div className="analytics-card" style={{ marginTop: 0 }}>
            <EmptyScreen height={400} />
          </div>
        )}
      </div>
    );
  })
);

export default Overall;
